import { IoArrowBackSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  onClick?: () => void;
  to?: string;
  fallbackUrl?: string;
}

const BackButton = ({ onClick, to, fallbackUrl }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else if (window.history.length > 1 && window.history.state && window.history.state.idx > 0) {
      window.history.back();
    } else if (fallbackUrl) {
      navigate(fallbackUrl);
    } else {
      window.history.back();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      style={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: "1px solid #e0e0e0",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "#f5f5f5";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "#fff";
      }}
    >
      <IoArrowBackSharp size={20} color="#2e4a3f" />
    </button>
  );
};

export default BackButton;